export enum AvatarApiUrl {
    AvatarTokenAndRegion = '/avatar/speech/token',
    AvatarSupportedLocales = '/avatar/locale/reconized',
}
